import { useEffect, useState } from 'react';

import { menuPageDialogOpened } from 'features/menu-page';
import { useStoreSelectorLang } from './useStoreSelectorLang';

import type { ChangeEvent } from 'react';
import type { StoreId } from 'shared/domain';

export function useStoreSelector(props: Props) {
  const { open, storeId, onClose, changeStore } = props;

  const [selectedStoreId, setSelectedStoreId] = useState(storeId);

  const menuPageDialog = menuPageDialogOpened();
  const lang = useStoreSelectorLang();

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSelectedStoreId(Number(event.target.value) as StoreId);
  };

  const handleCTA = () => {
    changeStore(selectedStoreId);
    onClose();
  };

  useEffect(() => {
    if (open) menuPageDialog.dispatch(true);
    else menuPageDialog.dispatch(false);
    return () => {
      menuPageDialog.dispatch(false);
    };
  }, [open]);

  return {
    lang,
    selectedStoreId,
    handleOnChange,
    handleCTA,
  };
}

interface Props {
  open: boolean;
  storeId: StoreId;
  onClose: () => void;
  changeStore: (id: StoreId) => void;
}
